import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CrowdinOtaService } from 'src/app/services/crowdin-ota/crowdin-ota.service';
import { LanguageService } from 'src/app/services/language.service';
import { TranslationService } from 'src/app/services/translation.service';
import { Location } from '@angular/common';


@Component({
  selector: 'app-language-selection-page',
  templateUrl: './language-selection-page.component.html',
  styleUrls: ['./language-selection-page.component.scss']
})
export class LanguageSelectionPageComponent implements OnInit {

  @Output() public islanguagePageVisible = new EventEmitter<any>();
  @Output() public sendLangId = new EventEmitter<any>();
  allLanguages: any[] = [];
  translationData = [];
  raceId: any = '';
  constructor(private readonly translationService: TranslationService,
    private readonly _languageService: LanguageService,
    private readonly _crowdinOtaService: CrowdinOtaService,
    private readonly _router: Router,
    private readonly location: Location,
  ) { }

  ngOnInit(): void {
   ;
    this.allLanguages = this.translationService.supportedLanguagesForDisplay;
  }

  public closeLanguagePicker() {
    this._languageService.showLanguageSelectionPage(false);
  }

  public emitLangId(id: any) {
    this.sendLangId.emit(id);
    this.islanguagePageVisible.emit(false);
  }

  public async switchLanguage(language: string): Promise<void> {
    const pattern = /\/[a-z]{2}-[A-Z]{2}(?=\/|$)/;
    const currentUrl = this._router.url;
    let updatedUrl = '';
    if (pattern.test(currentUrl)) {
      updatedUrl = currentUrl.replace(pattern, `/${language}`);
    } else {
      // If no language pattern found, prepend the language to the URL
      updatedUrl = `/${language}${currentUrl}`;
    }

    this.location.replaceState(updatedUrl);
    const languageCode = language.split('-')[0];

    try {
      await this._crowdinOtaService.useLanguage(languageCode);
      console.log(`Switched to ${languageCode}`);
      setTimeout(() => {
        this.closeLanguagePicker();
        localStorage.setItem('language', language);
        localStorage.setItem('languagePicked', 'true');
      }, 10);
    } catch (error) {
      console.error('Error switching language:', error);
    }

  }


  public addRaceIdWithLanguage() {
    let raceLang = {
      'languagePicked': true,
      'raceid': this.raceId
    }
    localStorage.setItem('languagePicked', JSON.stringify(raceLang))
  }
}
